<template>
  <div>
    <Header />
    <div class="profile">
      <el-form
        :model="userInfo"
        :rules="rules"
        ref="userForm"
        label-width="144px"
        :hide-required-asterisk="true"
      >
        <h4>个人信息</h4>
        <template v-if="Object.keys(fixed_attr).length || attrs.length">
          <el-form-item v-if="fixed_attr.avatar" :label="fixed_attr.avatar.attr" prop="avatar">
            <el-upload
              :action="uploadUrl"
              :show-file-list="false"
              list-type="picture"
              :on-success="uploadSuccess"
              :headers="headers"
              accept="image/gif, image/jpeg, image/jpg, image/png"
              style="display: inline-block"
            >
              <img v-if="userInfo.avatar" class="avatar" :src="userInfo.avatar" />
              <div v-else class="cover">
                <img src="~@/assets/images/login/regist-info-camera.png" />
                <p>上传头像</p>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item
            v-if="fixed_attr.nickname"
            :label="fixed_attr.nickname.attr"
            prop="nickname"
          >
            <el-input v-model="userInfo.nickname" style="width: 430px"></el-input>
          </el-form-item>
          <el-form-item v-if="fixed_attr.sex" :label="fixed_attr.sex.attr" prop="sex">
            <el-select v-model="userInfo.sex" filterable style="width: 260px">
              <el-option :value="0" label="男"></el-option>
              <el-option :value="1" label="女"></el-option>
              <el-option :value="3" label="保密"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="fixed_attr.birthday"
            :label="fixed_attr.birthday.attr"
            prop="birthday"
          >
            <el-date-picker
              v-model="userInfo.birthday"
              type="date"
              placeholder="请选择"
              :picker-options="options"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            v-if="fixed_attr.local_city"
            :label="fixed_attr.local_city.attr"
            prop="district_id"
          >
            <AreaSelect
              class="area-select"
              :provinceId="userInfo.province_id"
              :cityId="userInfo.city_id"
              :districtId="userInfo.district_id"
              @change="areaChange"
            ></AreaSelect>
            <!-- <el-input v-model="userInfo.address" style="width:650px;display:block"></el-input> -->
          </el-form-item>

          <el-form-item
            :class="attr.type == 10 ? 'is-more-upload' : ''"
            v-for="(attr, index) in attrs"
            :label="attr.attr"
            :key="attr.id"
            :prop="'attr' + index"
          >
            <el-select
              v-model="userInfo['attr' + index]"
              v-if="attr.type == 1"
              filterable
              style="width: 260px"
            >
              <el-option
                v-for="item in attr.value"
                :value="item.id"
                :key="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
            <el-checkbox-group v-model="userInfo['attr' + index]" v-if="attr.type == 2">
              <el-checkbox v-for="item in attr.value" :key="item.id" :label="item.id">
                {{ item.name }}
              </el-checkbox>
            </el-checkbox-group>
            <el-input
              v-model="userInfo['attr' + index]"
              style="width: 430px"
              v-if="attr.type == 3"
            ></el-input>
            <el-input
              v-model="userInfo['attr' + index]"
              style="width: 430px"
              v-if="attr.type == 6"
            ></el-input>
            <el-input
              type="textarea"
              resize="none"
              placeholder="请输入"
              v-model="userInfo['attr' + index]"
              v-if="attr.type == 4"
            ></el-input>
            <template v-if="attr.type == 5">
              <AreaSelect
                class="area-select"
                :provinceId="userInfo['attr' + index + 'province_id']"
                :cityId="userInfo['attr' + index + 'city_id']"
                :districtId="userInfo['attr' + index]"
                :index="index"
                @change="areaChangeMore"
              ></AreaSelect>
              <el-input
                v-model="userInfo['attr' + index + 'address']"
                style="width: 650px; display: block"
              ></el-input>
            </template>
            <el-date-picker
              v-model="userInfo['attr' + index]"
              type="date"
              placeholder="请选择"
              v-if="attr.type == 7"
              style="width: 260px"
            ></el-date-picker>
            <el-date-picker
              v-model="userInfo['attr' + index]"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
              v-if="attr.type == 8"
            ></el-date-picker>
            <template v-if="attr.type == 9">
              <el-upload
                class="el-upload--picture-card"
                @click.native="currentClickIndex(index)"
                :action="uploadUrl"
                :show-file-list="false"
                list-type="picture"
                :on-success="uploadSuccessSingle"
                :headers="headers"
                accept="image/gif, image/jpeg, image/jpg, image/png"
              >
                <img
                  v-if="userInfo['attr' + index]"
                  class="single"
                  :src="userInfo['attr' + index]"
                />
                <i v-else class="el-icon-plus"></i>
              </el-upload>
            </template>
            <el-upload
              ref="upload"
              :action="uploadUrl"
              list-type="picture-card"
              :headers="headers"
              :file-list="attr.fileList"
              :limit="9"
              :multiple="true"
              :on-success="uploadSuccessMore"
              :on-remove="handleRemove"
              :on-exceed="uploadExceed"
              accept="image/gif, image/jpeg, image/jpg, image/png"
              v-if="attr.type == 10"
            >
              <i @click="currentClickIndex(index)" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item class="submit-btn">
            <el-button type="primary" @click="saveUser">提交</el-button>
          </el-form-item>
        </template>
        <Empty v-else class="empty" title="数据加载中！" />
      </el-form>
    </div>
    <Footer v-if="$route.name != 'Download'" />
  </div>
</template>
<script>
import AreaSelect from '@/components/AreaSelect.vue';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
const buildConfig = require('@/build/' + process.env.BUILD_ENV + '.js');

export default {
  name: 'RegistInformation',
  components: {
    Header,
    Footer,
    AreaSelect,
  },
  data() {
    return {
      userInfo: {},
      rules: {
        avatar: [{ required: true, message: '头像不能为空', trigger: 'blur' }],
        nickname: [{ required: true, message: '昵称不能为空', trigger: 'blur' }],
        sex: [{ required: true, message: '性别不能为空', trigger: 'change' }],
        birthday: [{ required: true, message: '出生日期不能为空', trigger: 'change' }],
        district_id: [{ required: true, message: '所在城市不能为空', trigger: 'change' }],
      },
      uploadUrl: buildConfig.BASE_URL + '/api/app/public/img',
      headers: { Authorization: 'Bearer ' + sessionStorage.pr_webToken },
      options: {
        disabledDate: function (date) {
          return date > new Date();
        },
      },
      fixed_attr: [],
      attrs: [],
      currentUploadIndex: 0,
    };
  },
  async created() {
    let data = await this.$http.get('/api/app/user/collect', {}, false, sessionStorage.pr_webToken);
    this.setRules(data.fixed_attr, 'avatar');
    this.setRules(data.fixed_attr, 'birthday', 'change');
    if (data.fixed_attr.local_city) {
      this.$set(this.rules, 'district_id', [
        {
          required: data.fixed_attr.local_city.is_required == 1,
          message: data.fixed_attr.local_city.attr + '不能为空',
          trigger: 'change',
        },
      ]);
      this.$set(this.userInfo, 'province_id', data.fixed_attr.local_city.user_value.province_id);
      this.$set(this.userInfo, 'city_id', data.fixed_attr.local_city.user_value.city_id);
      this.$set(this.userInfo, 'district_id', data.fixed_attr.local_city.user_value.district_id);
    }
    this.setRules(data.fixed_attr, 'nickname');
    this.setRules(data.fixed_attr, 'sex', 'change');
    this.fixed_attr = data.fixed_attr;
    this.setAttrs(data);
    this.$nextTick(() => {
      window.$('.is-more-upload .el-form-item__label').append('<span>最多可传9张</span>');
    });
  },
  methods: {
    setAttrs(data) {
      for (let i = 0; i < data.attrs.length; i++) {
        let trigger = 'blur';
        switch (data.attrs[i].type) {
          case 1:
            this.$set(
              this.userInfo,
              'attr' + i,
              // data.attrs[i].user_value
              //   ? parseInt(data.attrs[i].user_value.attr_val)
              //   : "",
              this.getAttrValue(data.attrs[i], 1),
            );
            trigger = 'change';
            break;
          case 2:
            this.$set(
              this.userInfo,
              'attr' + i,
              this.getAttrValue(data.attrs[i], 2),
              // data.attrs[i].user_value
              //   ? data.attrs[i].user_value.attr_val
              //       .split(",")
              //       .map(function (item) {
              //         return +item;
              //       })
              //   : [],
            );
            trigger = 'change';
            break;
          case 3:
          case 4:
          case 6:
          case 7:
          case 9:
            this.$set(
              this.userInfo,
              'attr' + i,
              this.getAttrValue(data.attrs[i], 3),
              // data.attrs[i].user_value ? data.attrs[i].user_value.attr_val : "",
            );
            break;
          // case 4:
          //   this.$set(
          //     this.userInfo,
          //     "attr" + i,
          //     this.getAttrValue(data.attrs[i], 3),
          //   );
          //   trigger = "change";
          //   break;
          case 5:
            this.$set(
              this.userInfo,
              'attr' + i + 'province_id',
              this.getAttrValue(data.attrs[i], 4, 'province_id'),
              // data.attrs[i].user_value
              //   ? data.attrs[i].user_value.province_id
              //   : "",
            );
            this.$set(
              this.userInfo,
              'attr' + i + 'city_id',
              this.getAttrValue(data.attrs[i], 4, 'city_id'),
              // data.attrs[i].user_value ? data.attrs[i].user_value.city_id : "",
            );
            this.$set(
              this.userInfo,
              'attr' + i,
              this.getAttrValue(data.attrs[i], 4, 'district_id'),
              // data.attrs[i].user_value
              //   ? data.attrs[i].user_value.district_id
              //   : "",
            );
            this.$set(
              this.userInfo,
              'attr' + i + 'address',
              this.getAttrValue(data.attrs[i], 4, 'address'),
              // data.attrs[i].user_value ? data.attrs[i].user_value.address : "",
            );
            trigger = 'change';
            break;
          // case 6:
          //   this.$set(
          //     this.userInfo,
          //     "attr" + i,
          //     this.getAttrValue(data.attrs[i], 3),
          //     // data.attrs[i].user_value ? data.attrs[i].user_value.attr_val : "",
          //   );
          //   break;
          // case 7:
          //   this.$set(
          //     this.userInfo,
          //     "attr" + i,
          //     this.getAttrValue(data.attrs[i], 3),
          //     // data.attrs[i].user_value ? data.attrs[i].user_value.attr_val : "",
          //   );
          //   trigger = "change";
          //   break;
          case 8:
            if (data.attrs[i].user_value) {
              this.$set(this.userInfo, 'attr' + i, [
                data.attrs[i].user_value.start_time * 1000,
                data.attrs[i].user_value.end_time * 1000,
              ]);
            } else {
              this.$set(this.userInfo, 'attr' + i, '');
            }
            trigger = 'change';
            break;
          // case 9:
          //   this.$set(
          //     this.userInfo,
          //     "attr" + i,
          //     this.getAttrValue(data.attrs[i], 3),
          //     // data.attrs[i].user_value ? data.attrs[i].user_value.attr_val : "",
          //   );
          //   break;
          default:
            if (data.attrs[i].user_value) {
              this.$set(
                this.userInfo,
                'attr' + i,
                data.attrs[i].user_value.attr_val
                  ? JSON.parse(data.attrs[i].user_value.attr_val)
                  : [],
              );
              let arr = [];
              if (data.attrs[i].user_value.attr_val) {
                for (let value of JSON.parse(data.attrs[i].user_value.attr_val)) {
                  arr.push({
                    url: value,
                  });
                }
              }
              data.attrs[i].fileList = arr;
            } else {
              this.$set(this.userInfo, 'attr' + i, []);
              data.attrs[i].fileList = [];
            }
        }
        let arr = [
          {
            required: data.attrs[i].is_required == 1,
            message: data.attrs[i].attr + '不能为空',
            trigger: trigger,
          },
        ];
        this.$set(this.rules, 'attr' + i, arr);
      }
      this.attrs = data.attrs;
    },
    getAttrValue(data, type, address) {
      if (type == 1) {
        return data.user_value ? parseInt(data.user_value.attr_val) : '';
      } else if (type == 2) {
        return data.user_value
          ? data.user_value.attr_val.split(',').map(function (item) {
              return +item;
            })
          : [];
      } else if (type == 3) {
        return data.user_value ? data.user_value.attr_val : '';
      } else if (type == 4) {
        return data.user_value ? data.user_value[address] : '';
      }
    },
    setRules(data, prop, trigger = 'blur') {
      if (!Object.prototype.hasOwnProperty.call(data, prop)) {
        return;
      }
      this.$set(this.rules, prop, [
        {
          required: data[prop].is_required == 1,
          message: data[prop].attr + '不能为空',
          trigger: trigger,
        },
      ]);
      this.$set(this.userInfo, prop, data[prop].user_value);
    },
    areaChange(area) {
      this.userInfo.province_id = area.provinceId;
      this.userInfo.city_id = area.cityId;
      this.userInfo.district_id = area.districtId;
    },
    areaChangeMore(area) {
      this.userInfo['attr' + area.index + 'province_id'] = area.provinceId;
      this.userInfo['attr' + area.index + 'city_id'] = area.cityId;
      this.$set(this.userInfo, 'attr' + area.index, area.districtId);
    },
    getData(props) {
      let data = {};
      props.forEach((prop) => {
        if (Object.prototype.hasOwnProperty.call(this.userInfo, prop)) {
          data[prop] = this.userInfo[prop];
        }
      });
      return data;
    },
    saveUser() {
      this.$refs['userForm'].validate(async (valid) => {
        if (!valid) {
          return;
        }
        let data = this.getData([
          'nickname',
          'avatar',
          'sex',
          'province_id',
          'city_id',
          'district_id',
        ]);
        if (Object.prototype.hasOwnProperty.call(this.userInfo, 'birthday')) {
          data.birthday = this.userInfo.birthday
            ? new Date(this.userInfo.birthday).format('yyyy-MM-dd')
            : '';
        }
        let attrVals = [];
        for (let i = 0; i < this.attrs.length; i++) {
          let val = this.userInfo['attr' + i];
          let obj = {};
          obj.attr_id = this.attrs[i].id;
          switch (this.attrs[i].type) {
            case 1:
              obj.attr_val = val;
              break;
            case 2:
              obj.attr_val = val.join(',');
              break;
            case 3:
              obj.attr_val = val;
              break;
            case 4:
              obj.attr_val = val;
              break;
            case 5:
              obj.province_id = this.userInfo['attr' + i + 'province_id'];
              obj.city_id = this.userInfo['attr' + i + 'city_id'];
              obj.district_id = this.userInfo['attr' + i];
              obj.address = this.userInfo['attr' + i + 'address'];
              break;
            case 6:
              obj.attr_val = val;
              break;
            case 7:
              obj.attr_val = val;
              break;
            case 8:
              obj.start_time = val[0] / 1000 || '';
              obj.end_time = val[1] / 1000 || '';
              break;
            case 9:
              obj.attr_val = val;
              break;
            default:
              obj.attr_val = JSON.stringify(val);
          }
          attrVals.push(obj);
        }
        data.attr = JSON.stringify(attrVals);
        await this.$http.post('/api/app/user/collect/set', data, false, sessionStorage.pr_webToken);
        await this.$success('提交成功');
        this.$store.commit('login', sessionStorage.pr_webToken);
        await this.$store.dispatch('get_user_info');
        this.$router.push({ name: 'Home' });
      });
    },
    async uploadSuccess(response) {
      if (response.code != 200) {
        await this.$error(response.msg);
      } else {
        this.userInfo.avatar = response.data.path;
      }
    },
    currentClickIndex(index) {
      this.currentUploadIndex = index;
    },
    // 单图上传成功
    async uploadSuccessSingle(response) {
      if (response.code != 200) {
        await this.$error(response.msg);
      } else {
        this.userInfo['attr' + this.currentUploadIndex] = response.data.path;
      }
    },
    // 多图上传成功
    uploadSuccessMore(response, file, fileList) {
      if (response.code != 200) {
        this.$error(response.msg);
      } else {
        let fileBox = [];
        for (let value of fileList) {
          let path = value.response ? value.response.data.path : value.url;
          fileBox.push(path);
        }
        this.userInfo['attr' + this.currentUploadIndex] = fileBox;
      }
    },
    // 多图上传超出个数限制
    uploadExceed() {
      this.$warning('已达最大上传个数！');
    },
    // 移除图片
    handleRemove(file, fileList) {
      let fileBox = [];
      for (let value of fileList) {
        let path = value.response.data.path;
        fileBox.push(path);
      }
      // this.fileLength = fileBox.length;
      // fileBox = fileBox.join(',');
      this.userInfo['attr' + this.currentUploadIndex] = fileBox;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .header {
  height: 70px;
  line-height: 70px;
  box-shadow: none;
  .header-main,
  .userinfo,
  .right {
    display: none;
  }
  .main-container {
    height: 70px;
    .logo {
      margin-top: 20px;
    }
  }
}
.profile {
  width: 1200px;
  margin: 0 auto;
  padding: 90px 0 0;
  margin-bottom: 20px;
  border-radius: 0 0 10px 10px;
  ::v-deep .el-form {
    padding: 30px 70px 0;
    background-color: white;
    border-radius: 3px;
    min-height: calc(100vh - 209px);
    h4 {
      height: 45px;
      margin: 0;
      padding: 0;
      text-align: center;
      font-size: 25px;
      font-family: PingFangSC-Medium;
      color: #333333;
      line-height: 45px;
    }
    .el-form-item {
      margin: 0;
      padding: 29px 0;
      border-bottom: 1px solid #ededed;
      .el-form-item__label {
        // position: relative;
        margin-top: 8px;
        // padding-left: 13px;
        text-align: left;
        font-size: 18px;
        color: #333333;
        line-height: 24px;
        // &::before {
        //   position: absolute;
        //   top: 0;
        //   left: 0;
        // }
        span {
          display: block;
          font-size: 16px;
          color: #999;
        }
      }
      .el-form-item__content {
        & > div {
          display: block !important;
        }
        .el-upload--picture {
          display: block;
          width: 110px;
          height: 110px;
          .avatar {
            width: 110px;
            height: 110px;
            border-radius: 5px;
          }
          .cover {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 110px;
            height: 110px;
            background: rgba(0, 0, 0, 1);
            opacity: 0.3;
            border-radius: 5px;
            img {
              display: block;
              width: 32px;
              height: 25px;
            }
            p {
              margin-top: 15px;
              text-align: center;
              font-size: 14px;
              color: #fff;
              line-height: 14px;
            }
          }
        }
        .el-input__inner {
          height: 38px;
          line-height: 38px;
          border: 1px solid #dbdbdb;
          border-radius: 3px;
          font-size: 16px;
        }
        .el-textarea {
          textarea {
            border: 1px solid #dbdbdb;
            border-radius: 3px;
            font-size: 16px;
            min-height: 118px !important;
          }
        }
        .el-select__caret {
          font-size: 15px;
          color: #999;
          font-weight: bold;
        }
        .el-range-editor {
          display: inline-flex !important;
          padding: 0 10px;
        }
        .el-upload--picture-card {
          width: 116px;
          height: 116px;
          background: rgba(245, 245, 245, 1);
          border-radius: 3px;
          border: none;
          line-height: 116px;
          .el-icon-plus {
            width: 100%;
            font-size: 50px;
            color: #999;
            line-height: 110px;
          }
          .single {
            width: 100%;
            height: 100%;
          }
        }
        .el-upload-list--picture-card {
          .el-progress {
            display: block;
            width: 100px !important;
            height: 100px !important;
            .el-progress-circle {
              width: 100px !important;
              height: 100px !important;
            }
          }
        }
        .el-upload-list {
          .el-upload-list__item {
            width: 116px;
            height: 116px;
            margin: 0 9px 0 0;
            border-radius: 3px;
            .el-upload-list__item-status-label {
              display: none;
            }
          }
        }
        .area-select {
          display: block !important;
          margin-bottom: 10px;
          .el-select {
            width: 210px !important;
          }
        }
        input::-webkit-input-placeholder,
        textarea::-webkit-input-placeholder {
          font-weight: 400;
          color: #b3b3b3;
        }
        input::-moz-placeholder,
        textarea::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          font-weight: 400;
          color: #b3b3b3;
        }
        input:-moz-placeholder,
        textarea:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          font-weight: 400;
          color: #b3b3b3;
        }
        input:-ms-input-placeholder,
        textarea:-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          font-weight: 400;
          color: #b3b3b3;
        }
      }
    }
    .submit-btn {
      border: none;
      padding: 40px 0;
      button {
        display: block;
        width: 142px;
        height: 38px;
        padding: 0;
        border: none;
        font-size: 16px;
        color: #fff;
        font-weight: 400;
        line-height: 38px;
      }
    }
  }
}
</style>
